import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import { REJECT_TEXT_MAX, validateExceptionNote } from './review-rules';

interface Props {
  open: boolean;
  /** Nhãn các điều kiện xét duyệt chưa đạt hoặc chưa kiểm được. */
  labels: string[];
  onCancel: () => void;
  /** Admin đã ghi lý do, trang gọi tiếp tục xin mã Authenticator rồi duyệt. */
  onSubmit: (note: string) => void;
}

/** Hộp "Duyệt ngoại lệ" dùng chung: bắt buộc ghi lý do khi duyệt người chưa đạt điều kiện xét duyệt. */
const ExceptionNoteDialog = ({ open, labels, onCancel, onSubmit }: Props) => {
  const [note, setNote] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setNote('');
      setError(null);
    }
  }, [open]);

  const submit = () => {
    const err = validateExceptionNote(note);
    setError(err);
    if (err) return;
    onSubmit(note.trim());
  };

  return (
    <Modal
      open={open}
      title="Duyệt ngoại lệ"
      onCancel={onCancel}
      onOk={submit}
      okText="Tiếp tục duyệt"
      cancelText="Huỷ"
      destroyOnClose
    >
      <div className="flex flex-col gap-3 text-sm">
        <p>Tài khoản này chưa đạt các điều kiện xét duyệt sau:</p>
        <ul className="list-disc pl-5">
          {labels.map((l) => (
            <li key={l}>{l}</li>
          ))}
        </ul>
        <label className="flex flex-col gap-1">
          <span className="font-medium">Lý do duyệt ngoại lệ</span>
          <Input.TextArea
            aria-label="Lý do duyệt ngoại lệ"
            rows={3}
            maxLength={REJECT_TEXT_MAX}
            showCount
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
              setError(null);
            }}
            placeholder="Bạn ghi lý do Cab vẫn duyệt tài khoản này"
          />
        </label>
        {error && (
          <p role="alert" className="text-red-600">
            {error}
          </p>
        )}
      </div>
    </Modal>
  );
};

export default ExceptionNoteDialog;
